import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Импортируем локальные баннеры для второго баннера
import banner2 from "../../assets/banners/bannerlong2.png";
import bannereng2 from "../../assets/banners/bannerlongen2.png";
import bannerru2 from "../../assets/banners/bannerlongru2.png";

const BannersProfile = () => {
  const {t} = useTranslation();
  const [banner1Url, setBanner1Url] = useState(null);
  const [banner1Link, setBanner1Link] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Выбираем второй баннер в зависимости от языка
  const secondBannerImage = t.language === "ru" ? bannerru2 : 
                           t.language === "en" ? bannereng2 : 
                           banner2;

  useEffect(() => {
    const fetchBanner1 = async () => {
      setIsLoading(true);
      try {
        const response = await fetch("/api/banners_api.php");
        const data = await response.json();
        console.log("📦 Баннер из базы:", data);
        
        // Получаем первый баннер
        let firstBanner = null;
        
        if (Array.isArray(data)) {
          firstBanner = data.find(b => Number(b.position) === 1);
        } else if (data && typeof data === 'object') {
          firstBanner = data.banner1 || data;
        }
        
        if (firstBanner) {
          setBanner1Url(firstBanner.image_url || firstBanner.image);
          setBanner1Link(firstBanner.link_url || firstBanner.link);
        } else {
          setBanner1Url(null);
          setBanner1Link(null);
        }
      } catch (err) {
        console.error("❌ Ошибка загрузки баннера:", err);
        setBanner1Url(null);
        setBanner1Link(null);
      } finally {
        setIsLoading(false);
      }
    };
    
    fetchBanner1();
  }, []);

  const userId = localStorage.getItem("userId");

  if (isLoading) {
    return (
      <section className="w-full p-[20px] max-lg:p-2 max-xl:flex-col gap-6 max-md:gap-3 flex justify-between items-center">
        <div className="w-full h-[290px] max-sm:h-[160px] max-sm:rounded-xl max-md:h-[250px] max-lg:h-[200px] max-xl:h-[250px] max-2xl:h-[200px] bg-gray-200 rounded-[40px] animate-pulse"></div>
        <div className="w-full h-[290px] max-sm:h-[160px] max-md:h-[250px] max-sm:rounded-xl max-lg:h-[200px] max-xl:h-[250px] max-2xl:h-[200px] bg-gray-200 rounded-[40px] animate-pulse"></div>
      </section>
    );
  }

  return (
    <section className="w-full p-[20px] max-lg:p-2 max-xl:flex-col gap-6 max-md:gap-3 flex justify-between items-center">
      {/* Первый баннер (с сервера) */}
      <Link
        to={banner1Link ? banner1Link : `/BecomeaCandidate?userId=${userId}`}
        target={banner1Link?.startsWith('http') ? "_blank" : undefined}
        rel={banner1Link?.startsWith('http') ? "noopener noreferrer" : undefined}
        className="w-full h-[290px] max-sm:h-[160px] max-sm:rounded-xl max-md:h-[250px] max-lg:h-[200px] max-xl:h-[250px] max-2xl:h-[200px] transition-all duration-200 hover:shadow-[0_0_40px_#0066748e] rounded-[40px] relative overflow-hidden group"
      >
        <div className="absolute opacity-0 transition-all duration-200 shadow-[inset_0_0_80px_black] group-hover:opacity-20 inset-0 size-full bg-[#006674]"></div>
        {banner1Url ? (
          <img 
            className="size-full object-cover" 
            src={banner1Url} 
            alt="banner 1" 
          />
        ) : (
          <div className="w-full h-full bg-gradient-to-br from-gray-200 to-gray-300 flex items-center justify-center">
            <span className="text-gray-500 text-lg">{t("banner_placeholder") || "Баннер"}</span>
          </div>
        )}
      </Link>

      {/* Второй баннер (локальный) */}
      <Link
        to={`/BecomeaCandidate?userId=${userId}`}
        className="w-full h-[290px] max-sm:h-[160px] max-sm:rounded-xl max-md:h-[250px] max-lg:h-[200px] max-xl:h-[250px] max-2xl:h-[200px] transition-all duration-200 hover:shadow-[0_0_40px_#0066748e] rounded-[40px] relative overflow-hidden group"
      >
        <div className="absolute opacity-0 transition-all duration-200 shadow-[inset_0_0_80px_black] group-hover:opacity-20 inset-0 size-full bg-[#006674]"></div>
        <img 
          className="size-full object-cover" 
          src={secondBannerImage} 
          alt="banner 2" 
        />
      </Link>
    </section>
  );
};

export default BannersProfile;